import React, { useState, useEffect } from "react"
import dateFormat from 'dateformat';

import { Form, Row } from "react-bootstrap"

import InputField from '../elements/input'
import SelectField from '../elements/select'
import TextAreaField from '../elements/textarea'
import CheckboxField from '../elements/checkbox'
import RadioboxField from '../elements/radio'
import ButtonField from '../elements/button'
import HtmlBox from '../elements/html'
import ReCaptchaBox from '../elements/recaptcha'
import '../assets/styles/_index.scss'
import { phoneNumberValidation, getUrlParams } from "../../../common/utils/site_utlis"
import { getUser } from "@starberry/myaccount-website-utils"


function Rent_Home_2(props) {
  const userData = getUser();

  const [validated, setValidated] = useState(false);
  const [showerror, setShowerror] = useState(false);
  const [showerrormsg, setShowerrorMsg] = useState("");
  const [showthankyou, setThankyou] = useState(false);
  const [startDate, setStartDate] = useState();
  const [startTime, setStartTime] = useState();


  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectError, setSelectError] = useState(false);

  const myRef = React.createRef();

  const [show_living_option, setLivingOption] = useState(false);

  //console.log("location ==>", location, replace_slashes, props.title);


  var fields = ([
    {
        error_text: "Highlighted fields are required.",
        success_text: "Thank you, a member of our team will be in contact soon.",
    },
    {
      text: '<b>Lead Student Details</b>',
      element: "html",
      class: "mt-2 content_r-m mb-3 heading_text"
    },
    {
      text: '<b>Legal Name</b>',
      element: "html",
      class: "mt-2 content_r-m mb-3"
    },
    {
        grpmd: "12",
        label: "First",
        placeholder: "",
        name: "first_name",
        type: "text",
        element: "input",
        required: true,
        patternchk: "^[a-zA-Z0-9._-]+(\\s+[a-zA-Z0-9._-]+)*$",
        labelClass: "annual-txt",
        errorMsg: "Alphanumeric and special characters (-_.) are only allowed.",
        divclass: "form-wrap",
        defaultValue: userData?.name || ``
      }, 
      {
        grpmd: "12",
        label: "Last",
        placeholder: "",
        name: "last_name",
        type: "text",
        element: "input",
        required: true,
        patternchk: "^[a-zA-Z0-9._-]+(\\s+[a-zA-Z0-9._-]+)*$",
        labelClass: "annual-txt",
        errorMsg: "Alphanumeric and special characters (-_.) are only allowed.",
        divclass: "form-wrap",
        defaultValue: userData?.surname || ``
      },
      {
        text: '<b>Preferred Name</b><br />If you have a preferred name, please enter it here.',
        element: "html",
        class: "mt-2 content_r-m mb-3"
      },
      {
        grpmd: "12",
        label: "First",
        placeholder: "",
        name: "preferred_first_name",
        type: "text",
        element: "input",
        required: false,
        patternchk: "^[a-zA-Z0-9._-]+(\\s+[a-zA-Z0-9._-]+)*$",
        labelClass: "annual-txt",
        errorMsg: "Alphanumeric and special characters (-_.) are only allowed.",
        divclass: "form-wrap",
        defaultValue: userData?.name || ``
      }, 
      {
        grpmd: "12",
        label: "Last",
        placeholder: "",
        name: "preferred_last_name",
        type: "text",
        element: "input",
        required: false,
        patternchk: "^[a-zA-Z0-9._-]+(\\s+[a-zA-Z0-9._-]+)*$",
        labelClass: "annual-txt",
        errorMsg: "Alphanumeric and special characters (-_.) are only allowed.",
        divclass: "form-wrap",
        defaultValue: userData?.surname || ``
      },
      {
        grpmd: "12",
        label: "Your Age",
        placeholder: "",
        name: "age",
        type: "text",
        element: "input",
        required: false,
        labelClass: "annual-txt",
        divclass: "form-wrap",
      },
      {
        grpmd: "12",
        label: "Email Address",
        placeholder: "",
        name: "email",
        type: "email",
        element: "input",
        required: true,
        patternchk:"[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
        labelClass: "annual-txt",
        errorMsg: "Enter a valid email id, Ex: james123@gmail.com, JAMES123@GMAIL.COM.",
        divclass: "form-wrap",
        defaultValue: userData?.email || ``
      },
      {
        grpmd: "12",
        label: "Phone Number",
        placeholder: "",
        name: "telephone",
        type: "text",
        element: "input",
        required: true,
        patternchk:"^[+]*[0-9-()]+(\\s+[0-9-()]+)*.{9}$",
        labelClass: "annual-txt",
        errorMsg: "Enter a valid phone number, Ex: 01234 567 890.",
        divclass: "form-wrap",
        defaultValue: userData?.mobile || ``
      },
      {
        grpmd: "12",
        label: "Gender",
        placeholder: "",
        name: "gender",
        type: "text",
        element: "input",
        required: false,
        labelClass: "annual-txt",
        divclass: "form-wrap",
      }]
  )


  fields.push(
      {
        text: '<b>Your Course Information</b>',
        element: "html",
        class: "mt-2 content_r-m mb-3 heading_text"
      },
      {
        grpmd: "12",
        label: "Where are you studying?",
        placeholder: "",
        name: "studying_option",
        element: "radio",
        required: false,
        selected:"",
        values: ['University of Sussex', 'Brighton University', 'BIMM', 'Other'],
        labelClass: "annual-txt",
        class: "",
        divclass: "radio_wrap form-wrap full_wdth_check"
      }, 
      {
        grpmd: "12",
        label: "",
        placeholder: "",
        name: "studying_option_input",
        type: "text",
        element: "input",
        required: show_living_option ? true : false,
        labelClass: "annual-txt",
        divclass: `form-wrap ${show_living_option ? "" : "d-none"}`
      }
  )

  fields.push(
      {
        grpmd: "12",
        label: "Course Title",
        placeholder: "",
        name: "course_title",
        type: "text",
        element: "input",
        required: false,
        labelClass: "annual-txt",
        divclass: "form-wrap"
      },
      {
        grpmd: "12",
        label: "Current year of study?",
        placeholder: "",
        name: "current_year_study",
        type: "text",
        element: "input",
        required: false,
        labelClass: "annual-txt",
      },
      {
        text: 'E.g. first/second/third year or foundation/Masters/PHD',
        element: "html",
        class: "mt-0 content_r-m mb-5"
      },
      
      {
        grpmd: "12",
        label: "Please Confirm If",
        placeholder: "",
        name: "confirm_if",
        element: "radio",
        required: true,
        selected:"",
        values: ['You have a guarantor', 'You are able to pay 6 or 12 months rent in advance'],
        labelClass: "annual-txt",
        class: "",
        divclass: "radio_wrap form-wrap full_wdth_check"
      }, 
      {
        text: 'You must enter details for all tenants to live in the property before your application will be reviewed. E.g. if you are applying for a 5 bed house, you must submit details of all five tenants:',
        element: "html",
        class: "mt-0 content_r-m mb-3"
      },
      
  )

  fields.push(
      {
        grpmd: "12",
        label: "Add another housemate?",
        placeholder: "",
        name: "living_another_person",
        element: "radio",
        required: true,
        selected:"",
        values: ['Yes', 'No'],
        labelClass: "annual-txt",
        class: "",
        divclass: "radio_wrap form-wrap"
      },
      {
        grpmd: "6",
        name: "previous",
        type: "button",
        element: "button",
        value: "Previous",
        class: "btn btn-green",
        labelClass: "",
        customClass: "custom-button-wrapper mt-4 col-md-6",
        divclass: "form-wrap"
      },

      {
        grpmd: "6",
        name: "SUBMIT",
        type: "submit",
        element: "button",
        value: "Next",
        class: "btn btn-green",
        labelClass: "",
        customClass: "custom-button-wrapper mt-4 col-md-6",
        divclass: "form-wrap"
      },
  )


  const handlechange = event => {
    // remove initial empty spaces


    if(event.target.name === "studying_option"){
      if(event.target.value === "Other"){
          setLivingOption(true)
      } else{
          setLivingOption(false)
      }
    } 



    if (event.type === "select") {
      //event.value = event.value.trimStart()

      setSelectedOptions(event);
    } else {
      if (event.target.name === "telephone") {
        var valid_phone = phoneNumberValidation(event.target.value);
        if (valid_phone) {
          event.target.value = valid_phone;
        } else {
          event.target.value = '';
        }
      } else {
        event.target.value = event.target.value.trimStart()
      }
    }

  }


  const handleSubmit = event => {

    const form = event.currentTarget;

    //console.log("event =>", form);

    var form_obj_arr = Object.entries(form);

    //console.log("form_obj_arr =>", form_obj_arr.filter(item => item[1].required === true));

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setShowerror(true);
      setValidated(true);
      setThankyou(false);
      setShowerrorMsg(fields[0].error_text)

      if (selectedOptions?.value) {
        setSelectError(false);
      } else {
        setSelectError(true);
      }

      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
    else {

      event.preventDefault();
      const formsdata = (event.target);

      const json = {}
      Object.keys(formsdata).map(key => {

        if (formsdata[key].type === "checkbox") {
          if (formsdata[key].checked === true) {
            json[formsdata[key].name] = 'yes'
          }
        } else if (formsdata[key].type === "radio") {
          if (formsdata[key].checked === true) {
            json[formsdata[key].name] = formsdata[key].value
          }
        } else {
          json[formsdata[key].name] = formsdata[key].value
        }

      })

      
      json['name'] = json.first_name+' '+json.last_name;
      var params = getUrlParams();

      json['studying_option'] = show_living_option ? json.studying_option_input : json.studying_option ? json.studying_option : "";


      //console.log("formdata step2", json);

      props.setFormvaluesFunc(json);

      var tenant_inc = parseInt(props.tenant_details) + 1
      if(json.living_another_person === "Yes"){
        props.setTenantDetails(tenant_inc);
        props.setStep("step"+tenant_inc);
        
      } else{
        props.setStep("final");
      }

      props.setPrevStep("step1")

      //window.scrollTo(0,0)
      

      setValidated(false);
      setShowerror(false);
      // setSelectError(false);
      // setSelectedOptions({});

      // // reset form
      // const form = event.target
      // form.reset();
      // setStartDate();
      // setStartTime();

    }
  };

  const handleBack = () => {
    props.setTenantDetails(0);
    props.setStep("step0");
    props.setPrevStep("")
    window.scrollTo(0,0)
  }
  //console.log("selectedOptions", selectedOptions);

  return (
    <div className="form rent_form">

      {showerror && <div className="alert alert-danger">
        {showerrormsg}
      </div>}
      <div ref={myRef}></div>

      {showthankyou && <div className="alert alert-success">
        {fields[0].success_text}
      </div>}


      <Form name={fields[0].formname} id="step_1" className={props.classNames} action="/" method="post" noValidate validated={validated} onSubmit={handleSubmit} autoComplete="off">

        <Row className="custom-text-field-wrapper no_direction">
          {fields.map((field, index) => {
            if ("input" === field.element) {
              return (
                <InputField
                  name={field.name}
                  divclass={field.divclass}
                  grpmd={field.grpmd}
                  label={field.label}
                  ref={field.ref}
                  type={field.type}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  labelClass={field.labelClass}
                  required={field.required}
                  key={`${field.element}~${index}`}
                  pattern={field.patternchk}
                  handlechange={handlechange}
                  errorMsg={field.errorMsg}
                  startDate={field.type === 'valuation_date' ? startDate : ''}
                  setStartDate={field.type === 'valuation_date' ? setStartDate : ''}
                  startTime={field.type === 'valuation_time' ? startTime : ''}
                  setStartTime={field.type === 'valuation_time' ? setStartTime : ''}
                  defaultValue={field?.defaultValue}
                  min={field?.min}
                  max={field?.max}
                />
              );
            }
            if ("select" === field.element) {
              return (
                <SelectField
                  name={field.name}
                  divclass={field.divclass}
                  grpmd={field.grpmd}
                  label={field.label}
                  ref={field.ref}
                  required={field.required}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  labelClass={field.labelClass}
                  values={field.values}
                  key={`${field.element}~${index}`}
                  handlechange={handlechange}
                  componentprops={props}
                  //selectedValue={selectedOptions}
                  errorMsg={field.errorMsg}
                  isError={selectError}
                //isError= {Object.keys(selectError).length > 0 ? (selectError[field.name] ? '' : true) : ''}
                  optionWithLabel={true}
                />
              );
            }
            if ("textarea" === field.element) {
              return (
                <>

                  <TextAreaField
                    name={field.name}
                    divclass={field.divclass}
                    grpmd={field.grpmd}
                    label={field.label}
                    ref={field.ref}
                    rows={field.rows}
                    fieldClass={field.class}
                    labelClass={field.labelClass}
                    placeholder={field.placeholder}
                    required={field.required}
                    key={`${field.element}~${index}`}
                    handlechange={handlechange}
                    errorMsg={field.errorMsg}
                  />
                </>
              );
            }
            if ("checkbox" === field.element) {
              return (
                <CheckboxField
                  name={field.name}
                  divclass={field.divclass}
                  ref={field.ref}
                  value={field.value}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={handlechange}
                />
              );
            }
            if ("radio" === field.element) {
              return (
                <RadioboxField
                  name={field.name}
                  divclass={field.divclass}
                  ref={field.ref}
                  values={field.values}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={handlechange}
                  label={field.label}
                />
              );
            }
            if ("html" === field.element) {
              return (
                <HtmlBox
                  text={field.text}
                  fieldClass={field.class}
                  key={`${field.element}~${index}`}
                />
              );
            }
            // if ("captcha" === field.element) {
            //   return (
            //     <ReCaptchaBox
            //       fieldClass={field.class}
            //       captRef={field.captchaRef}
            //       key={`${field.element}~${index}`}
            //       handleonVerify={handleonVerify}
            //     />
            //   );
            // }
            if ("button" === field.element) {
              return (
                <>

                  <ButtonField
                    name={field.name}
                    fieldClass={field.class}
                    type={field.type}
                    value={field.value}
                    key={`${field.element}~${index}`}
                    grpmd={field.grpmd}
                    customClass={field.customClass}
                    handlClick={handleBack}
                  />

                </>
              );
            }
          })
          }
        </Row>
      </Form>

    </div>
  );
}


const RentHomeStep2 = (props) => (
  <Rent_Home_2 {...props} />

)

export default RentHomeStep2